import Lottie from "lottie-web";

export function initWorlMap() {
    const lottieContainer = document.getElementById('world-map');

    if (!lottieContainer) return;

    // Retrieve the animation path from the data-path attribute
    const animationPath = lottieContainer.getAttribute('data-lottie-path');

    if (!animationPath) {
        console.error('No animation path specified in data-path attribute.');
        return;
    }

    // Initialize the Lottie animation with the dynamic path
    const animation = Lottie.loadAnimation({
        container: lottieContainer, // The DOM element that will contain the animation
        renderer: 'svg',            // Render type ('svg', 'canvas', or 'html')
        loop: true,                // Whether to loop the animation
        autoplay: false,            // Whether to play automatically
        path: animationPath         // Path to the animation JSON file from data attribute
    });

    // Create an Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Play the animation when it enters the viewport
                animation.play();
            } else {
                // Pause the animation when it exits the viewport
                animation.pause();
            }
        });
    }, {
        root: null,                  // Use the viewport as the container
        threshold: 0.2               // Trigger when 20% of the element is visible
    });

    // Observe the Lottie container
    observer.observe(lottieContainer);
}
